export default function trimString(value: string, trimCount?: number) {
	const count = trimCount || 50;
	return value.length > count ? `${value.slice(0, count)}...` : value;
}
